module.exports = __webpack_public_path__ + "img/GS_Profile-Kamo Mothiba.0d7f37c3.png";